const coordinationSwiper = new Swiper(".swiper-container", {
    // 自動再生（true:自動再生する、false:自動再生しない）
    //   autoplay: {
    //     delay: 5000,
    //   },
    // スライド方向（水平方向）
    direction: "horizontal",
    // ループ
    loop: true,
    // 表示枚数
    slidesPerView: 1,
    breakpoints: {
      749: {
        slidesPerView: 1,
      },
    },
    // 前後の矢印
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });